// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-trade-barometer/form-item-trade-barometer.component.scss
// module id = 977
// module chunks = 0